export const COMPONENT_NAME = "admin-config-page";
